window.ajaxForm = function(url, form, callback) {
    loading('ON');
    var send_data = form.serialize();
    ajaxCall(url, send_data, callback);
};

window.ajaxCall = function (url, send_data, callback) {
    // $(".btn_prevent").prop("disabled", true);
    // $(".btn_prevent > i").removeClass("d-none");


    if (isset(CONSOLE_LOG) && CONSOLE_LOG === true) {
        consoleLog(url);
        consoleLog(send_data);
    }

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    $.ajax({
        url: url,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        data: send_data,
        type: "POST",
        datatype: "json",
        success: callback,
        error: function (xhr, status, errorThrown) {
            ajaxError(xhr);
        },
        complete: function (xhr, status) {
            if (ajaxComplete(xhr)) {
                setAlarm(xhr.responseJSON);
                setInvite(xhr.responseJSON);
            }
        }
    });
};

window.ajaxRawForm = function (url, form, callback) {
    loading('ON');
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    var form_data = form[0];
    var formData = new FormData(form_data);

    $.ajax({
        url: url,
        processData: false,
        contentType: false,
        data: formData,
        type: "POST",
        datatype: "json",
        success: callback,
        error: function (xhr, status, errorThrown) {
            ajaxError(xhr);
        },
        complete: function (xhr, status) {
            ajaxComplete(xhr);
        }
    });
};

window.checkError = function (json) {

    if (isset(json.error.code)) {

        switch (json.error.code) {

            case 'NOT_ENOUGH_POINT':
            case 'NEED_CHAT_ITEM':
                toastAlert(json.error.message);
                setTimeout(function () {
                    redirect('/point');
                }, 2500);
                break;

            case 'ROOM_NOT_EXIST':
            case 'USER_NOT_EXIST':
                toastAlert(json.error.message);
                setTimeout(function () {
                    replace('/chat');
                }, 2500);
                break;

            case 'CHAT_NEED_AUTH':
                toastAlert(json.error.message);
                setTimeout(function () {
                    redirect('/etc/check_auth_phone');
                }, 2500);
                break;

            default:
                toastAlert(json.error.message);
                break;
        }
    }
};

window.setPolling = function (kind) {

    $(document).on('visibilitychange', function() {
        if(document.visibilityState === 'hidden') {
            if (POLLING_STOP_ON_HIDDEN) {
                stopPolling();
            }
        } else {
            if (POLLING_STOP_ON_HIDDEN) {
                resumePolling();
            }
        }
    });

    getPollingData(kind);
    POLLING_INTERVAL_ID = setInterval(function () {
        if (POLLING_STOP) {
            return true;
        }
        getPollingData(kind);
    }, POLLING_INTERVAL);
};

window.getPollingData = function (kind) {

    var sendData;

    switch (kind) {
        case 'MEET.AREA.USER_LIST':
            sendData = 'selectAreaCode1=' + $("#selectAreaCode1").val();
            sendData += '&selectAreaCode2=' + $("#selectAreaCode2").val();
            sendData += '&select_lat=' + $("#select_lat").val();
            sendData += '&select_lng=' + $("#select_lng").val();
            ajaxCall("/meet/area/userList", sendData, function (json) {
                setAlarm(json);
                setInvite(json);
                areaUserList(json);
            });
            break;

        case 'MEET.USER.USER_LIST':
            ajaxCall("/meet/user/userList", null, function (json) {
                setAlarm(json);
                setInvite(json);
                userUserList(json);
            });
            break;

        case 'MEET.CONFIRM.USER_LIST':
            ajaxCall("/meet/confirm/userList", null, function (json) {
                setAlarm(json);
                setInvite(json);
                confirmUserList(json);
            });
            break;

        case 'CHAT.ROOM_LIST':
            ajaxCall("/chat/roomList", null, function (json) {
                setAlarm(json);
                setInvite(json);
                chatRoomList(json);
            });
            break;

        case 'CHAT.ROOM.MESSAGE_LIST':
            sendData = 'room_id=' + $("#form_send_message_room_id").val();
            sendData += '&uuid=' + $("#form_send_message_uuid").val();
            sendData += '&last_message_id=' + $("#form_send_message_other_last_message_id").val();
            sendData += '&project=' + $("#form_send_message_project").val();

            ajaxCall("/chat/room/messageList", sendData, function (json) {
                // setAlarm(json);
                // setInvite(json);
                messageList(json);
            });
            break;

        case 'COMMON.ALARM':
            ajaxCall("/common/alarm", null, function (json) {
                setAlarm(json);
                setInvite(json);
            });
            break;
    }
};

window.stopPolling = function () {
    //clearInterval(POLLING_INTERVAL_ID);
    POLLING_STOP = true;
};

window.resumePolling = function () {
    // if (POLLING_INTERVAL_ID !== 0) {
    //     setPolling(POLLING_KIND);
    // }
    POLLING_STOP = false;
};

window.setAlarm = function (json) {
    if (isset(json.unreadCount)) {
        if (parseInt(json.unreadCount) > 0) {
            $(".unread_count").html(json.unreadCount);
        } else {
            $(".unread_count").html('');
        }
        if ('function' === typeof jnRequestSetBadge) {
            jnRequestSetBadge(json.unreadCount);
        }
    }
};

window.setInvite = function (json) {
    if (isset(json.inviteInfo)) {
        stopPolling();
        //consoleLog(json.inviteInfo);
        openRecvInviteModal(json.inviteInfo);
    }
};




window.ajaxError = function (xhr) {

    if (isset(CONSOLE_LOG) && CONSOLE_LOG === true) {
        consoleLog(xhr);
    }

    switch (xhr.status) {

        case 401:
            toastAlertRedirect('다시 로그인해 주세요.', 2000, '/login');
            break;

        case 412:
            toastAlertRedirect('로그아웃 되었습니다.', 2000, '/login');
            break;

        case 422:
            if (isset(xhr.responseJSON.errors[(Object.keys(xhr.responseJSON.errors))[0]][0])) {
                toastAlert(xhr.responseJSON.errors[(Object.keys(xhr.responseJSON.errors)[0])][0]);
            } else {
                toastAlert('입력값이 올바르지 않습니다.');
            }
            break;

        case 403:
            toastAlert('허용되지 않는 요청입니다.');
            break;

        case 413:
            toastAlert('허용된 파일 사이즈를 초과 했습니다.');
            break;

        case 419:
            window.location.reload();
            break;

        case 0:
            break;

        case 500:
        default:
            toastAlert('잘못된 요청입니다.[' + xhr.status + ']');
            break;
    }
};

window.ajaxComplete = function (xhr) {

    loading('OFF');

    if (xhr === undefined || xhr.responseJSON === undefined) {
        return false;
    } else {

        if (isset(CONSOLE_LOG) && CONSOLE_LOG === true) {
            consoleLog(xhr.responseJSON);
        }

        switch (xhr.responseJSON.resultType) {
            case 'OK':
                if (isset(xhr.responseJSON.message)) {
                    toastAlert(xhr.responseJSON.message);
                }
                break;

            case 'ERROR':
                checkError(xhr.responseJSON);
                break;

            default:
                break;
        }
    }
    return true;
};

window.clientLog = function (log_command, log_info) {
    ajaxCall('/common/client_log', 'log_command=PAYMENT_METHOD&log_info=' + log_info, function() {});
};

